
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class PriceTypeDialog extends SiteEntityDialog<PriceTypeRow, any> {
        protected getFormKey() { return PriceTypeForm.formKey; }
        protected getIdProperty() { return PriceTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PriceTypeRow.localTextPrefix; }
        protected getNameProperty() { return PriceTypeRow.nameProperty; }
        protected getService() { return PriceTypeService.baseUrl; }
        protected getDeletePermission() { return PriceTypeRow.deletePermission; }
        protected getInsertPermission() { return PriceTypeRow.insertPermission; }
        protected getUpdatePermission() { return PriceTypeRow.updatePermission; }

        protected form = new PriceTypeForm(this.idPrefix);

    }
}